import acceptances from '../data/acceptances';
import _ from 'lodash';
import scoreService from './ScoreService';
export default {
    /**
     * Get schools by level (school type)
     * @param level
     * @params schools
     * @returns {Array}
     */
    getSchoolsByLevel(level, schools) {
        return _.filter(schools, school => school.level === level);
    },
    /**
     * Get the color for the percentages based on out of state percent
     * @param percent
     * @returns {*}
     */
    getAcceptanceColor(percent) {
        const acceptance = _.find(
            acceptances,
            acceptance => percent >= acceptance.from && percent <= acceptance.to
        );
        return acceptance.color;
    },
    /**
     * Get color of state chip based on user state
     * @param schoolState
     * @param userState
     * @returns {string}
     */
    getStateColor(schoolState, userState) {
        return schoolState === userState ? 'green' : 'blue-grey lighten-2';
    },
    /**
     * Ordered school list by percent
     * @param schoolList
     * @returns {Array}
     */
    getOrderedSchoolListByPercent(schoolList) {
        return _.orderBy(schoolList, 'percentage', 'desc');
    },

    /**
     * Get school list by level
     * @param level
     * @params schools
     * @returns {[]}
     * TODO refactor level to tier
     */
    getSchoolListByLevel(level, schools) {
        const schoolListByLevel = [];

        _.each(level.results, result => {
            const schoolsByLevel = this.getSchoolsByLevel(
                result.school_type,
                schools
            );
            const orderedSchoolListByPercent = this.getOrderedSchoolListByPercent(
                schoolsByLevel
            );
            const schoolNumber = scoreService.getSchoolNumberOfPercent(
                level.total_schools,
                result.percent
            );

            schoolListByLevel.push({
                schoolNumber: schoolNumber,
                schoolType: result.school_type,
                schoolList: orderedSchoolListByPercent,
            });
        });

        return _.orderBy(schoolListByLevel, 'schoolNumber', 'desc');
    },
};
